import { createSelector } from 'reselect';

const selectPlatformWebsites = (state: any) => state.platformWebsites;


export const selectPlatformWebsitesCurrentItem = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.current);

export const selectPlatformWebsitesListItems = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectPlatformWebsitesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPlatformWebsitesQueryItems = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.query);

export const selectPlatformWebsitesCreatedItem = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.create);

export const selectPlatformWebsitesUpdatedItem = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.update);

export const selectPlatformWebsitesReadItem = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.read);

export const selectPlatformWebsitesDeletedItem = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.delete);

export const selectPlatformWebsitesSearchedItems = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.search);

export const selectPlatformWebsitesItemsCount = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.count);

export const selectPlatformWebsitesItemsFilter = createSelector([selectPlatformWebsites], (platformWebsites) => platformWebsites.filter);